import {
  ADD_FRAME_TYPE_SUCCESS,
  DELETE_FRAME_TYPE_SUCCESS,
  GET_ALL_FRAME_TYPES_FAILURE,
  GET_ALL_FRAME_TYPES_REQUEST,
  GET_ALL_FRAME_TYPES_SUCCESS,
  UPDATE_FRAME_TYPE_SUCCESS,
} from "../constants/frameTypes";

const initialState = {
  frameTypesList: [],
  loading: false,
  error: null,
};

export const frameTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_FRAME_TYPES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_ALL_FRAME_TYPES_SUCCESS:
      return {
        ...state,
        frameTypesList: action.payload,
        loading: false,
      };

    case GET_ALL_FRAME_TYPES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    case ADD_FRAME_TYPE_SUCCESS:
      const {
        frameType: { is_active, frame_type, image, _id: id },
      } = action.payload;
      const newFrameShape = { is_active, frame_type, image, id };
      return {
        ...state,
        frameTypesList: [...state.frameTypesList, newFrameShape],
      };

    case DELETE_FRAME_TYPE_SUCCESS:
      return {
        ...state,
        frameTypesList: state.frameTypesList.filter((x) => x.id !== action.payload),
      };

    case UPDATE_FRAME_TYPE_SUCCESS:
      return {
        ...state,
        frameTypesList: state.frameTypesList.map((x) => {
          if (x.id === action.payload.id) {
            return action.payload;
          }
          return x;
        }),
      };
      
    default:
      return state;
      break;
  }
};

// export const addFrameShapeReducer = (state = { addFrameShape: {} }, action) => {
//   switch (action.type) {
//     case ADD_FRAME_TYPE_REQUEST:
//       return { ...state, loading: true };
//     case ADD_FRAME_TYPE_SUCCESS:
//       return {
//         loading: false,
//         addFrameShape: action?.payload,
//       };
//     case ADD_FRAME_TYPE_FAILURE:
//       return {
//         loading: false,
//         error: action?.payload,
//       };
//     default:
//       return state;
//   }
// };

// export const getAllFrameShapeReducer = (
//   state = { getAllFrameShape: [] },
//   action
// ) => {
//   switch (action.type) {
//     case GET_ALL_FRAME_TYPE_REQUEST:
//       return { getAllFrameShape: [], loading: true };
//     case GET_ALL_FRAME_TYPE_SUCCESS:
//       return {
//         loading: false,
//         getAllFrameShape: action?.payload,
//       };
//     case GET_ALL_FRAME_TYPE_FAILURE:
//       return {
//         loading: false,
//         error: action?.payload,
//       };
//     default:
//       return state;
//   }
// };
